import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { GithubSyncIndicatorComponent } from '@mode/github/ui';

export const DowngradedGithubUIModule = angular
  .module('downgraded-github-ui', [])
  .directive('modeGithubSyncIndicator', downgradeComponent({ component: GithubSyncIndicatorComponent })).name;
